import PropTypes from 'prop-types';
import React from "react";
import { useTranslation } from 'react-i18next';
import styles from './steps.module.scss';
// import './style.css';

function checkStatus(index, currentValue) {
    if (index < currentValue) return "completed"
    else if (index == currentValue) return "active"
    else return
}

const Steps = ({ current_step, stateChanger, items }) => {
    const { t } = useTranslation()
    if (!items.map(({ index }) => index).includes(current_step)) {
        return
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.progressUl}>
                {items.map((data, index) => {
                    return (
                        <li class={styles[checkStatus(data.index, current_step)]} key={index}>
                            <div className={styles.progressContent}>
                                <p>{data.title}</p>
                            </div>
                            <div className={styles.progressIndicatorWrapper}>
                                <a className={styles.progressMiddle} onClick={() => { stateChanger(data.index) }}>
                                    <div className={styles.progressInner}>{data.icon}</div>
                                </a>
                            </div>
                        </li>
                    )
                })}
            </div>
            <div className={styles.currentStepTitle}>{items.find(({ index }) => index === current_step)?.title}</div>
        </div>
    )
}
Steps.propTypes = {
    current_step: PropTypes.number,
    stateChanger: PropTypes.func,
    items: PropTypes.array
}
export default Steps